/**
 * The ONE place the application says where its artwork lives.
 *
 * The recovered modules were written against the prototype layout and defaulted their image
 * sources to `../../redesign/assets/X`. In the built application that resolves to
 * `/redesign/assets/X`, which does not exist, so every image rendered broken. Measured 2026-09-06
 * in a real browser: nine broken images on the Today surface alone.
 *
 * The repair is this constant plus `app/scripts/copy-art.mjs`, which copies the referenced masters
 * out of the frozen `redesign/assets/` tree into `app/public/art/`. The masters are never modified.
 *
 * These paths are DEFAULTS for fixture and demo data. A real host passes a real URL as a prop, and
 * from #26 onward most of these become server data. The default still has to resolve, because the
 * fixture gallery in #25 renders every surface standalone.
 */

/** Root-absolute, so it resolves the same from every hash route and after a direct refresh. */
export const ART_BASE = '/art';

/** Build an artwork URL. Prefer this over writing the base into a template by hand. */
export function art(fileName) {
  return `${ART_BASE}/${fileName}`;
}

/**
 * The accepted lantern artwork for the hold-to-light ritual. Today and the kiosk both read THIS, so
 * the kiosk cannot drift back to the fallback glyph (#580 D3: it passed no image at all).
 */
export const LANTERN_MARK = art('lantern-mark.png');

/**
 * The badge catalog's icon KEYS that have a Blender medallion in `app/public/badges/` (#583 S9-art,
 * made by `render_badges()` in `app/scripts/blender/village-kit.py`). The catalog stores a key, not a
 * URL, so a key outside this list has no picture and the card keeps its drawn glyph.
 */
export const BADGE_ART_KEYS = Object.freeze(['flame', 'crown', 'star', 'medal', 'trophy', 'target', 'sun', 'moon', 'lightning', 'calendar', 'rocket']);

/** A catalog icon key → its badge image URL, or `undefined` for an unknown key (the glyph stays). */
export function badgeArt(key) {
  return BADGE_ART_KEYS.includes(key) ? `/badges/${key}.webp` : undefined;
}
